import { CharactersCounter } from '@openx/components-core/lib/CharactersCounter/CharactersCounter';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField';
import { optionalFieldLabel } from '@openx/components-form/optionalFieldLabel';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form';
import { InventoryListFormFields } from '@openx/types/inventoryList';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { getFieldPlaceholders, getFormLabels } from '../../../constants';

export const DetailsSection = () => {
  const formLabels = useMemo(() => getFormLabels(), []);
  const fieldPlaceholders = useMemo(() => getFieldPlaceholders(), []);
  const observableDescription = useWatch({ name: InventoryListFormFields.DESCRIPTION });

  return (
    <FormSection title="Details" rightColumnSize={RIGHT_COLUMN_WIDTH} divider>
      <RHFTextField
        name={InventoryListFormFields.NAME}
        label={formLabels[InventoryListFormFields.NAME]}
        placeholder={fieldPlaceholders[InventoryListFormFields.NAME]}
        fullWidth
        dataTest="name"
      />

      <RHFTextField
        name={InventoryListFormFields.DESCRIPTION}
        label={optionalFieldLabel(formLabels[InventoryListFormFields.DESCRIPTION])}
        placeholder={fieldPlaceholders[InventoryListFormFields.DESCRIPTION]}
        multiline
        rows={3}
        fullWidth
        margin="dense"
        slotProps={{ htmlInput: { maxLength: 255 }, formHelperText: { component: 'div' } }}
        helperText={<CharactersCounter maxValue={255} currentValue={observableDescription?.length} />}
        dataTest="description"
      />
    </FormSection>
  );
};
